import React, { Component } from "react";
import "./requisites.scss";
import Button from "@components/button";
import logo from "@img/logo.svg";
import PopupMess from "./PopupMess";
import qrcode from "./img/qrcode.svg";

const requisites = [
	{ title: "Год основания", value: "12/2006" },
	{ title: "Генеральный директор", value: "Эйдлин Денис Григорьевич" },
	{
		title: "Расчетный счет в ПАО «АК БАРС» БАНК",
		value: "40702810400020003396"
	},
	{
		title: 'Корреспондентский счет в ПАО "АК БАРС" БАНК',
		value: "30101810000000000805"
	},
	{ title: "ИНН", value: "1660096477" },
	{ title: "КПП", value: "166001001" },
	{ title: "БИК", value: "049205805" },
	{
		title: "Юридический адрес",
		value: "Россия, Республика Татарстан, 420087, г.Казань, ул.Крылова, д.3"
	},
	{ title: "Телефон", value: "+7 (843) 262-80-80" },
	{ title: "Факс", value: "+7 (843) 261-17-79" },
	{ title: "E-mail", value: "office@transkart.ru" },
	{ title: "Сайт", value: "https://transkart.ru" }
];


	const currentYear = new Date().getFullYear();

	const print = () => {
		window.print();
	};


	class Requisites extends React.Component {
    constructor(props) {
        super(props);
        this.state = {ShowModal: false};
    }
    
		togglePopup = () => {
			this.setState({
				ShowModal: false
			});
		};
		qrpay = () => {
			console.log(this.state.ShowModal)
			this.setState({
				ShowModal: true
			});
			console.log(this.state.ShowModal)
		}

		scrollup = () => {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		}


	render() {
		console.log(this.state.ShowModal)
	return (
		<section className="full-width requisites">
			<div className="grid-container">
				<div className="row">
					<div className="col-xs-12 col-md-offset-2 col-md-8 col-sm-offset-1 col-sm-10">
						<h2>Реквизиты</h2>
					</div>
					<div className="container">
						<React.Fragment>
							{this.state.ShowModal ? (
								<PopupMess
									text="QR код для банковского перевода"
									mess= <img src={qrcode} alt="qrcode"/>
									closePopup={this.togglePopup}
								/>
							) : null}
						</React.Fragment>
					</div>

					<div className="section-print col-xs-12 col-md-offset-2 col-md-8 col-sm-offset-1 col-sm-10">
						<img
							className="logo-print"
							src={logo}
							alt="Логотип транспортной карты"
						/>
						<h4>Транспортная карта</h4>
						<ul className="simple-table">
							{requisites.map(({ title, value }) => (
								<li key={value} className="simple-table__item">
									<div className="simple-table__item__title">
										<p>{title}</p>
									</div>
									<div className="simple-table__item__value">
										<p>{value}</p>
									</div>
								</li>
							))}
						</ul>
						<p className="copyright">АО «Транспортная карта» {currentYear}</p>
					</div>

					<div className="col-xs-12 col-md-offset-2 col-md-8 col-sm-offset-1 col-sm-10">
						<Button onClick={print} className="button" title="Распечатать" />
					</div>
				</div>
			</div>
		</section>
	);
};
}

export default Requisites
